<template>
  <div class="footer">
    <div class="box">
      <div class="section">
        <div class="title">产品系列</div>
        <div class="divider"></div>
        <ul class="list">
          <li class="item"
              v-for="item in products"
              :key="item.id">
            <router-link :to="item.url">{{item.name}}</router-link>
          </li>
        </ul>
      </div>
      <div class="section">
        <div class="title">关于公司</div>
        <div class="divider"></div>
        <ul class="list">
          <li class="item"
              v-for="item in about"
              :key="item.id">
            <router-link :to="item.url">{{item.name}}</router-link>
          </li>
        </ul>
      </div>
      <div class="section">
        <div class="title">最新资讯</div>
        <div class="divider"></div>
        <ul class="list">
          <li class="item"
              v-for="item in information"
              :key="item.id">
            <router-link :to="item.url">{{item.name}}</router-link>
          </li>
        </ul>
      </div>
      <div class="section">
        <div class="title">联系我们</div>
        <div class="divider"></div>
        <ul class="list">
          <li class="item"
              v-for="item in contacts"
              :key="item.id">
            {{item.name}}
          </li>
        </ul>
      </div>
    </div>
    <div class="beian">
      © 2018 Anchora,Inc. All Rights Reserved. 嘉兴安尚云信信息科技有限公司 版权所有
      <a style="margin-left: 10px;"
         href="http://beian.gov.cn/portal/registerSystemInfo?recordcode=33040202000130">浙公网安备 33040202000130号</a>
      <a style="margin-left: 10px;"
         href="http://beian.miit.gov.cn/state/outPortal/loginPortal.action">浙ICP备12032155号-1</a>
    </div>

  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      products: [
        {
          id: 1,
          name: "人工智能平台",
          url: "/portal/ai"
        },
        {
          id: 2,
          name: "大模型应用引擎系统",
          url: "/portal/lmaes"
        },
      ],
      about: [
        {
          id: 1,
          name: "公司介绍",
          url: "/introduction"
        },
        {
          id: 2,
          name: "企业历程",
          url: "/introduction"
        }
      ],
      information: [
        {
          id: 1,
          name: "新闻",
          url: "/news??type=1"
        },
        {
          id: 2,
          name: "活动",
          url: "/news?type=2"
        }
      ],
      contacts: [
        {
          id: 1,
          name: "上海总公司:上海市徐汇区龙耀路18号X3栋3楼"
        },
        {
          id: 2,
          name: "嘉兴研发中心:嘉兴市南湖区亚太路705号清华研究院10楼"
        },
        {
          id: 4,
          name: "业务咨询：13033677897"
        },
        // {
        //   id: 5,
        //   name: "用户交流群:QQ:1039327587"
        // },
        // {
        //   id: 6,
        //   name: "市场邮箱:marketing@anchora.me"
        // },
        {
          id: 3,
          name: "市场邮箱：sales@anchora.me"
        },
      ]
    };
  },
  computed: {
    isMore: function() {
      if (this.$route.path.search("/more") != -1) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style>
.footer a:hover {
  color: #fff !important;
}

@media (min-width: 992px) {
  .footer {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 50px 0 0 0;
    background: radial-gradient(
      circle,
      rgba(50, 55, 61, 1),
      rgba(28, 27, 35, 1)
    );
  }

  .footer-fixed {
    position: fixed;
    bottom: 0;
    width: 100%;
  }

  .footer .box {
    width: 74%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  .footer .box .section {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .footer .box .section .title {
    width: 96px;
    height: 24px;
    font-size: 24px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 24px;
  }

  .footer .box .section h3 {
    font-size: 20px;
    font-family: SimHei;
    font-weight: bold;
    color: rgba(255, 255, 253, 1);
  }

  .footer .box .section .divider {
    width: 96px;
    height: 2px;
    background-color: #ffffff;
    margin: 22px 0;
  }

  .footer .box .section ul {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .footer .box .section ul li {
    margin-bottom: 23px;
  }

  .footer .box .section ul li,
  .footer a,
  .footer p {
    font-size: 12px;
    font-family: SimHei;
    font-weight: 400;
    color: rgba(255, 255, 253, 0.7) !important;
  }

  .footer p {
    margin-top: 33px;
  }

  .footer .beian {
    width: 72%;
    border-top: 1px solid rgba(255, 255, 253, 0.2);
    font-size: 12px;
    font-family: SimHei;
    font-weight: 400;
    color: rgba(255, 255, 253, 0.7) !important;
    padding: 20px 0;
  }
}

@media (max-width: 992px) {
  .footer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 200px;
    background: radial-gradient(
      circle,
      rgba(50, 55, 61, 1),
      rgba(28, 27, 35, 1)
    );
  }

  .footer-fixed {
    position: fixed;
    bottom: 0;
    width: 100%;
  }

  .footer .box {
    width: 90%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  .footer .box .section {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .footer .box .section:last-child {
    align-items: center;
  }

  .footer .box .section h3 {
    font-size: 0.16rem;
    font-family: SimHei;
    font-weight: bold;
    color: rgba(255, 255, 253, 1);
  }

  .footer .box .section .divider {
    width: 15px;
    height: 1px;
    background: rgba(255, 255, 255, 0.6);
    margin: 5px 0 10px;
  }

  .footer .box .section ul {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .footer .box .section ul li {
    margin-bottom: 10px;
  }

  .footer .box .section ul li,
  .footer a,
  .footer p {
    font-size: 0.12rem;
    font-family: SimHei;
    font-weight: 400;
    color: rgba(255, 255, 253, 0.7) !important;
  }

  .footer img {
    width: 50px;
  }

  .footer p {
    margin-top: 0.16rem;
  }

  .footer .beian {
    width: 72%;
    border-top: 1px solid rgba(255, 255, 253, 0.2);
    font-size: 12px;
    font-family: SimHei;
    font-weight: 400;
    color: rgba(255, 255, 253, 0.7) !important;
    padding: 20px 0;
  }
}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/Footer.vue